import {Dayjs} from "dayjs";
import {PaymentPlanFrequency} from "../../../../enums";

export const getMaxDateToReschedule = (frequency: PaymentPlanFrequency, originalDueDate: Dayjs): Dayjs => {
  switch (frequency) {
    case "weekly":
      return originalDueDate.add(8, "day");
    case "bi_weekly":
      return originalDueDate.add(14, "day");
    case "monthly":
    default:
      return originalDueDate.add(1, "month");
  }
};

export const getShouldDisableDate = (frequency: PaymentPlanFrequency, originalDueDate: Dayjs) => {
  return (date: Dayjs): boolean => {
    const normalizedDate = date.startOf("day");
    const normalizedDueDate = originalDueDate.startOf("day");

    switch (frequency) {
      case "weekly":
        if (normalizedDate.day() === normalizedDueDate.day()) {
          return true;
        }
        break;
      case "bi_weekly": {
        const daysDiff = normalizedDate.diff(normalizedDueDate, "day");
        if (daysDiff >= 0 && daysDiff % 14 === 0) {
          return true;
        }
        break;
      }
      case "monthly":
      default:
        if (normalizedDate.date() === normalizedDueDate.date()) {
          return true;
        }
        break;
    }

    return false;
  };
};

export const getIsDateValid = (
  selectedDate: Dayjs | null,
  minDate: Dayjs,
  maxDate: Dayjs,
  shouldDisableDate: (date: Dayjs) => boolean
): boolean => {
  if (!selectedDate || selectedDate.isBefore(minDate, "day") || selectedDate.isAfter(maxDate, "day")) {
    return false;
  }
  return !shouldDisableDate(selectedDate);
};
